import React from 'react';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Menu from './components/Menu';
import Home from './components/Home';
import SearchBar from './components/SearchBar';
import AboutMe from './components/AboutMe';
import Divorcios from './components/Services/Divorcios';
import Sucesiones from './components/Services/Sucesiones';
import Compraventa  from './components/Services/Compraventa';
import Arrendamiento from './components/Services/Arrendamiento';
import Escrituras from './components/Services/Escrituras';
import Fideicomisos from './components/Services/Fideicomisos';
import Apostillas from './components/Services/Apostillas';
import CertTrad from './components/Services/CertTrad';
import Desistimiento from './components/Services/Desistimiento';
import ExpReg from './components/Services/ExpReg';
import Liquidaciones from './components/Services/Liquidaciones';
import Poderes from './components/Services/Poderes';
import RegDig from './components/Services/RegDig';
import AcuVolu from './components/Services/AcuVolu';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

function App() {
  return (
    <Router>
      <div className="bg-slate-200">
        <NavBar />
        <SearchBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/aboutme" element={<AboutMe />} />
          <Route path="/divorcios" element={<Divorcios />} />
          <Route path="/sucesiones" element={<Sucesiones />} />
          <Route path="/contratos de compraventa" element={<Compraventa />} />
          <Route path="/contratos de arrendamiento" element={<Arrendamiento />} />
          <Route path="/escrituras" element={<Escrituras />} />
          <Route path="/fideicomisos" element={<Fideicomisos />} />
          <Route path="/apostillas" element={<Apostillas />} />
          <Route path="/certificados de tradicion" element={<CertTrad />} />
          <Route path="/desistimientos" element={<Desistimiento />} />
          <Route path="/expedicion de registros" element={<ExpReg />} />
          <Route path="/liquidaciones" element={<Liquidaciones />} />
          <Route path="/poderes" element={<Poderes />} />
          <Route path="/registros digitales" element={<RegDig />} />
          <Route path="/acuerdos de voluntades" element={<AcuVolu />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;